"use strict";
// tslint:disable
/**
 * Sleekflow General Api
 * Sleekflow General Api
 *
 * The version of the OpenAPI document: api
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConversationMessageApi = void 0;
var runtime_1 = require("../runtime");
/**
 * no description
 */
var ConversationMessageApi = /** @class */ (function (_super) {
    __extends(ConversationMessageApi, _super);
    function ConversationMessageApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConversationMessageApi.prototype.conversationMessagesForwardMessagePost = function (_a, opts) {
        var travisBackendMessageDomainViewModelsForwardMessageInput = _a.travisBackendMessageDomainViewModelsForwardMessageInput;
        var headers = {
            'Content-Type': 'application/json'
        };
        return this.request({
            url: '/ConversationMessages/ForwardMessage',
            method: 'POST',
            headers: headers,
            body: travisBackendMessageDomainViewModelsForwardMessageInput
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ConversationMessageApi.prototype.conversationMessagesGetMessagePost = function (_a, opts) {
        var travisBackendControllersMessageControllersConversationMessageControllerGetMessageByMessageIdInput = _a.travisBackendControllersMessageControllersConversationMessageControllerGetMessageByMessageIdInput;
        var headers = {
            'Content-Type': 'application/json'
        };
        return this.request({
            url: '/ConversationMessages/GetMessage',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersMessageControllersConversationMessageControllerGetMessageByMessageIdInput
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ConversationMessageApi.prototype.conversationMessagesGetMessagesPost = function (_a, opts) {
        var travisBackendControllersMessageControllersConversationMessageControllerGetConversationMessagesInput = _a.travisBackendControllersMessageControllersConversationMessageControllerGetConversationMessagesInput;
        var headers = {
            'Content-Type': 'application/json'
        };
        return this.request({
            url: '/ConversationMessages/GetMessages',
            method: 'POST',
            headers: headers,
            body: travisBackendControllersMessageControllersConversationMessageControllerGetConversationMessagesInput
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ConversationMessageApi.prototype.conversationMessagesSendFileMessagePost = function (_a, opts) {
        var conversationId = _a.conversationId, messageChecksum = _a.messageChecksum, channel = _a.channel, messageGroupName = _a.messageGroupName, receiverDeviceUUID = _a.receiverDeviceUUID, facebookReceiverId = _a.facebookReceiverId, whatsappReceiverId = _a.whatsappReceiverId, whatsapp360dialogReceiverId = _a.whatsapp360dialogReceiverId, receiverId = _a.receiverId, webClientSenderId = _a.webClientSenderId, webClientReceiverId = _a.webClientReceiverId, weChatReceiverOpenId = _a.weChatReceiverOpenId, lineReceiverId = _a.lineReceiverId, sMSReceiverId = _a.sMSReceiverId, viberReceiverId = _a.viberReceiverId, whatsappCloudApiReceiverId = _a.whatsappCloudApiReceiverId, telegramReceiverId = _a.telegramReceiverId, emailFrom = _a.emailFrom, emailTo = _a.emailTo, emailCC = _a.emailCC, subject = _a.subject, messageType = _a.messageType, messageContent = _a.messageContent, files = _a.files, fileURLs = _a.fileURLs, fileNames = _a.fileNames, localTimestamp = _a.localTimestamp, quotedMsgId = _a.quotedMsgId, quickReplyId = _a.quickReplyId, scheduleSentAt = _a.scheduleSentAt, channelId = _a.channelId, channelIdentityId = _a.channelIdentityId, messageTag = _a.messageTag, analyticTags = _a.analyticTags, paymentIntentId = _a.paymentIntentId;
        (0, runtime_1.throwIfNullOrUndefined)(conversationId, 'conversationId', 'conversationMessagesSendFileMessagePost');
        var headers = {};
        var formData = new FormData();
        if (conversationId !== undefined) {
            formData.append('ConversationId', conversationId);
        }
        if (messageChecksum !== undefined) {
            formData.append('MessageChecksum', messageChecksum);
        }
        if (channel !== undefined) {
            formData.append('Channel', channel);
        }
        if (messageGroupName !== undefined) {
            formData.append('MessageGroupName', messageGroupName);
        }
        if (receiverDeviceUUID !== undefined) {
            formData.append('ReceiverDeviceUUID', receiverDeviceUUID);
        }
        if (facebookReceiverId !== undefined) {
            formData.append('FacebookReceiverId', facebookReceiverId);
        }
        if (whatsappReceiverId !== undefined) {
            formData.append('WhatsappReceiverId', whatsappReceiverId);
        }
        if (whatsapp360dialogReceiverId !== undefined) {
            formData.append('Whatsapp360dialogReceiverId', whatsapp360dialogReceiverId);
        }
        if (receiverId !== undefined) {
            formData.append('ReceiverId', receiverId);
        }
        if (webClientSenderId !== undefined) {
            formData.append('WebClientSenderId', webClientSenderId);
        }
        if (webClientReceiverId !== undefined) {
            formData.append('WebClientReceiverId', webClientReceiverId);
        }
        if (weChatReceiverOpenId !== undefined) {
            formData.append('WeChatReceiverOpenId', weChatReceiverOpenId);
        }
        if (lineReceiverId !== undefined) {
            formData.append('LineReceiverId', lineReceiverId);
        }
        if (sMSReceiverId !== undefined) {
            formData.append('SMSReceiverId', sMSReceiverId);
        }
        if (viberReceiverId !== undefined) {
            formData.append('ViberReceiverId', viberReceiverId);
        }
        if (whatsappCloudApiReceiverId !== undefined) {
            formData.append('WhatsappCloudApiReceiverId', whatsappCloudApiReceiverId);
        }
        if (telegramReceiverId !== undefined) {
            formData.append('TelegramReceiverId', telegramReceiverId);
        }
        if (emailFrom !== undefined) {
            formData.append('EmailFrom', emailFrom);
        }
        if (emailTo !== undefined) {
            formData.append('EmailTo', emailTo);
        }
        if (emailCC !== undefined) {
            formData.append('EmailCC', emailCC);
        }
        if (subject !== undefined) {
            formData.append('Subject', subject);
        }
        if (messageType !== undefined) {
            formData.append('MessageType', messageType);
        }
        if (messageContent !== undefined) {
            formData.append('MessageContent', messageContent);
        }
        if (files !== undefined) {
            files.forEach(function (element) { return formData.append('files', element); });
        }
        if (fileURLs !== undefined) {
            fileURLs.forEach(function (element) { return formData.append('fileURLs', element); });
        }
        if (fileNames !== undefined) {
            fileNames.forEach(function (element) { return formData.append('fileNames', element); });
        }
        if (localTimestamp !== undefined) {
            formData.append('LocalTimestamp', localTimestamp);
        }
        if (quotedMsgId !== undefined) {
            formData.append('QuotedMsgId', quotedMsgId);
        }
        if (quickReplyId !== undefined) {
            formData.append('QuickReplyId', quickReplyId);
        }
        if (scheduleSentAt !== undefined) {
            formData.append('ScheduleSentAt', scheduleSentAt);
        }
        if (channelId !== undefined) {
            formData.append('ChannelId', channelId);
        }
        if (channelIdentityId !== undefined) {
            formData.append('ChannelIdentityId', channelIdentityId);
        }
        if (messageTag !== undefined) {
            formData.append('MessageTag', messageTag);
        }
        if (analyticTags !== undefined) {
            analyticTags.forEach(function (element) { return formData.append('AnalyticTags', element); });
        }
        if (paymentIntentId !== undefined) {
            formData.append('PaymentIntentId', paymentIntentId);
        }
        return this.request({
            url: '/ConversationMessages/SendFileMessage',
            method: 'POST',
            headers: headers,
            body: formData
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    ConversationMessageApi.prototype.conversationMessagesSendMessagePost = function (_a, opts) {
        var travisBackendMessageDomainViewModelsExtendedConversationMessageViewModel = _a.travisBackendMessageDomainViewModelsExtendedConversationMessageViewModel;
        var headers = {
            'Content-Type': 'application/json'
        };
        return this.request({
            url: '/ConversationMessages/SendMessage',
            method: 'POST',
            headers: headers,
            body: travisBackendMessageDomainViewModelsExtendedConversationMessageViewModel
        }, opts === null || opts === void 0 ? void 0 : opts.responseOpts);
    };
    return ConversationMessageApi;
}(runtime_1.BaseAPI));
exports.ConversationMessageApi = ConversationMessageApi;
